(function () {
  'use strict';
  const filterFields = ['wheel', 'width', 'unit', 'valve', 'length', 'material', 'availability', 'brand', 'min', 'max', 'sort'];
  const fields = filterFields;
  const emptyState = () => ({ wheel: '', width: '', unit: 'mm', valve: '', length: '', material: '', availability: '', brand: '', min: '', max: '', sort: 'featured' });
  function readState(search) {
    const params = new URLSearchParams(search), state = emptyState();
    fields.forEach(key => { state[key] = params.get('tube_' + key) || state[key]; });
    if (!['featured', 'price-low', 'price-high', 'title'].includes(state.sort)) state.sort = 'featured';
    return state;
  }
  function priceBound(value) {
    const number = Number(value);
    return Number.isFinite(number) && number >= 0 ? Math.round(number * 100) : NaN;
  }
  const isInStock = variant => variant.inStock === true;
  function matchingBands(variant, state) {
    if (variant.eligible !== true) return [];
    const width = Number(state.width);
    if (state.width !== '' && (!Number.isFinite(width) || width <= 0 || !['mm', 'in'].includes(state.unit))) return [];
    return (variant.bands || []).filter(band => {
      if (!band.wheel || (state.wheel && band.wheel !== state.wheel)) return false;
      if (state.width === '') return true;
      return band.unit === state.unit && band.min !== null && band.min !== undefined && band.max !== null && band.max !== undefined &&
        Number.isFinite(Number(band.min)) && Number.isFinite(Number(band.max)) && Number(band.min) <= width && width <= Number(band.max);
    });
  }
  function matchesVariant(variant, state) {
    const specified = state.wheel || state.width !== '' || state.valve || state.length || state.material;
    return !(specified && variant.eligible !== true) &&
      (!(state.wheel || state.width !== '') || matchingBands(variant, state).length > 0) &&
      (!state.valve || variant.valve_type === state.valve) &&
      (!state.length || (variant.valve_length_mm !== null && variant.valve_length_mm !== undefined && Number(variant.valve_length_mm) === Number(state.length))) &&
      (!state.material || variant.material === state.material) &&
      (state.availability === '' || (state.availability === '1' && isInStock(variant)) || (state.availability === '0' && !variant.available) || (state.availability === '2' && variant.available && !isInStock(variant))) &&
      (state.min === '' || variant.price >= priceBound(state.min)) &&
      (state.max === '' || variant.price <= priceBound(state.max));
  }
  function filterProducts(products, state) {
    return products.flatMap((product, position) => {
      if (state.brand && product.vendor !== state.brand) return [];
      const variants = product.variants.filter(variant => matchesVariant(variant, state));
      if (!variants.length) return [];
      const available = variants.filter(variant => variant.available);
      const stocked = variants.filter(isInStock);
      const candidates = (stocked.length ? stocked : available.length ? available : variants).slice().sort((a, b) => a.price - b.price);
      return [{ product, variants, chosen: candidates[0], available: !!available.length, inStock: !!stocked.length, position, price: candidates[0].price, variablePrice: candidates.some(v => v.price !== candidates[0].price) }];
    }).sort((a, b) => {
      if (state.sort === 'price-low') return a.price - b.price || a.position - b.position;
      if (state.sort === 'price-high') return b.price - a.price || a.position - b.position;
      if (state.sort === 'title') return a.product.title.localeCompare(b.product.title);
      return Number(b.inStock) - Number(a.inStock) || Number(b.available) - Number(a.available) || a.position - b.position;
    });
  }
  function hasVariantFilters(state) {
    return ['wheel', 'width', 'valve', 'length', 'material', 'availability', 'min', 'max'].some(key => state[key] !== '');
  }
  function validateProducts(data) {
    if (!data || data.complete !== true || !Array.isArray(data.products) || data.products.length > 250 || data.productCount !== data.products.length || !data.strings) return false;
    const productIds = new Set(), variantIds = new Set();
    let count = 0;
    const optionalText = value => value === null || (typeof value === 'string' && value.length > 0 && value.length <= 100);
    const validBand = band => band && typeof band.wheel === 'string' && band.wheel.length > 0 && band.wheel.length <= 100 && ['mm', 'in'].includes(band.unit) && (band.min === null || (typeof band.min === 'number' && Number.isFinite(band.min) && band.min > 0)) && (band.max === null || (typeof band.max === 'number' && Number.isFinite(band.max) && band.max > 0)) && (band.min === null || band.max === null || band.max >= band.min) && (band.iso_bsd_mm == null || (Number.isInteger(band.iso_bsd_mm) && band.iso_bsd_mm > 0));
    for (const product of data.products) {
      if (!product || typeof product !== 'object') return false;
      const id = String(product.id);
      if (!/^\d+$/.test(id) || productIds.has(id) || typeof product.title !== 'string' || typeof product.vendor !== 'string' || typeof product.url !== 'string' || !product.url.startsWith('/') || product.url.startsWith('//') || !Array.isArray(product.variants) || !product.variants.length || product.variantCount !== product.variants.length || product.variants.length > 250) return false;
      productIds.add(id);
      for (const variant of product.variants) {
        if (!variant || typeof variant !== 'object') return false;
        const variantId = String(variant.id);
        if (!/^\d+$/.test(variantId) || variantIds.has(variantId) || !Number.isInteger(variant.price) || variant.price < 0 || typeof variant.money !== 'string' || typeof variant.title !== 'string' || typeof variant.available !== 'boolean' || typeof variant.inStock !== 'boolean' || (variant.inStock && !variant.available) || typeof variant.eligible !== 'boolean' || !Array.isArray(variant.bands) || variant.bands.length > 30 || !variant.bands.every(validBand) || !optionalText(variant.valve_type) || !optionalText(variant.material) || !(variant.valve_length_mm === null || (Number.isInteger(variant.valve_length_mm) && variant.valve_length_mm > 0))) return false;
        variantIds.add(variantId); count++;
      }
    }
    return count <= 1500 && data.variantCount === count && ['shown', 'count', 'available', 'fits', 'length', 'valve', 'unknown', 'orderable', 'soldOut', 'from', 'remove', 'min', 'max', 'matched'].every(key => typeof data.strings[key] === 'string');
  }
  const api = { emptyState, readState, isInStock, matchesVariant, matchingBands, filterProducts, validateProducts, hasVariantFilters };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof document === 'undefined') return;
  const root = document.querySelector('#tos-tube-filter-preview');
  if (!root || root.dataset.ready) return;
  let data;
  try { data = JSON.parse(root.querySelector('[data-products]').textContent); } catch (error) { return; }
  if (!validateProducts(data)) return;
  const entry = new URL(location.href);
  const nativeKeys = [...entry.searchParams.keys()].filter(key => key.startsWith('filter.') || key === 'page' || key === 'sort_by');
  const collectionSegment = '/collections/' + root.dataset.collection;
  const segmentAt = entry.pathname.indexOf(collectionSegment);
  const collectionPath = segmentAt < 0 ? root.dataset.url : entry.pathname.slice(0, segmentAt) + collectionSegment;
  const taggedPath = entry.pathname.startsWith(collectionPath + '/');
  if (nativeKeys.length || taggedPath) {
    nativeKeys.forEach(key => entry.searchParams.delete(key));
    if (taggedPath) entry.pathname = collectionPath;
    location.replace(entry);
    return;
  }
  let variants = [];
  const form = root.querySelector('form'), grid = root.querySelector('[data-grid]'), more = root.querySelector('[data-more]');
  const sort = root.querySelector('select[name=sort]'), count = root.querySelector('[data-count]');
  let state = readState(location.search), limit = 24, filtered = [];
  const unique = values => [...new Set(values.filter(v => v !== null && v !== undefined && v !== '').map(String))];
  function refreshOptions() {
    variants = data.products.flatMap(p => p.variants);
    const eligible = variants.filter(v => v.eligible === true);
    const valuesFor = {
    wheel: unique(eligible.flatMap(v => v.bands.map(b => b.wheel))).sort((a, b) => a.localeCompare(b, undefined, { numeric: true })),
    valve: unique(eligible.map(v => v.valve_type)).sort(),
    length: unique(eligible.map(v => v.valve_length_mm)).sort((a, b) => Number(a) - Number(b)),
    material: unique(eligible.map(v => v.material)).sort(),
    brand: unique(data.products.map(p => p.vendor)).sort((a, b) => a.localeCompare(b))
  };
  Object.entries(valuesFor).forEach(([key, values]) => {
    const control = form.elements.namedItem(key); while (control.options.length > 1) control.remove(1);
    values.forEach(value => {
    const option = document.createElement('option'); option.value = value; option.textContent = value; form.elements.namedItem(key).append(option);
  }); });
  while (form.elements.availability.options.length > 3) form.elements.availability.remove(3);
  if (data.products.some(p => p.variants.some(v => v.available && !isInStock(v)))) {
    const option = document.createElement('option'); option.value = '2'; option.textContent = data.strings.orderable; form.elements.availability.append(option);
  }
  }
  const filterDetails = root.querySelector('.trp__filters');
  if (window.matchMedia('(max-width: 999px)').matches) filterDetails.open = false;
  function syncControls() {
    filterFields.filter(key => key !== 'sort').forEach(key => { form.elements.namedItem(key).value = state[key]; });
    sort.value = state.sort;
  }
  function urlState() {
    const url = new URL(location.href);
    [...fields, 'scope', 'category'].forEach(key => url.searchParams.delete('tube_' + key));
    fields.forEach(key => {
      if (state[key] && !(key === 'sort' && state[key] === 'featured') && !(key === 'unit' && state[key] === 'mm')) url.searchParams.set('tube_' + key, state[key]);
    });
    url.searchParams.delete('page');
    return url;
  }
  function productLink(result) {
    const url = new URL(result.product.url, location.origin);
    if (hasVariantFilters(state)) url.searchParams.set('variant', result.chosen.id);
    else url.searchParams.delete('variant');
    return url.pathname + url.search;
  }
  function renderCards(appendFrom = 0) {
    const fragment = document.createDocumentFragment();
    filtered.slice(appendFrom, limit).forEach(result => {
      const card = root.querySelector('[data-card]').content.firstElementChild.cloneNode(true), link = productLink(result);
      card.dataset.productId = result.product.id; card.dataset.variantId = result.chosen.id;
      card.querySelectorAll('a').forEach(a => { a.href = link; });
      const img = card.querySelector('img');
      if (result.product.image) img.src = result.product.image;
      else img.remove();
      img.alt = result.product.title;
      if (appendFrom === 0 && fragment.childElementCount < 4) img.loading = 'eager';
      card.querySelector('.trp__vendor').textContent = result.product.vendor;
      card.querySelector('.trp__title').textContent = result.product.title;
      card.querySelector('.trp__price').textContent = (result.variablePrice ? data.strings.from + ' ' : '') + result.chosen.money;
      const showMatch = hasVariantFilters(state);
      const match = card.querySelector('.trp__match');
      match.hidden = !showMatch;
      match.textContent = !showMatch || result.chosen.title === 'Default Title' ? '' : data.strings.matched + ': ' + result.chosen.title;
      const bands = matchingBands(result.chosen, state);
      const descriptions = unique(bands.map(band => {
        if (band.min === null || band.min === undefined || band.max === null || band.max === undefined) return band.wheel;
        return band.wheel + ' × ' + band.min + (Number(band.min) === Number(band.max) ? '' : '–' + band.max) + ' ' + band.unit;
      }));
      card.querySelector('.trp__fit').textContent = data.strings.fits + ': ' + (descriptions.length ? descriptions.join('; ') : data.strings.unknown);
      card.querySelector('.trp__fit').hidden = !showMatch || !result.chosen.eligible;
      const stock = card.querySelector('.trp__stock'); stock.textContent = result.inStock ? data.strings.available : result.available ? data.strings.orderable : data.strings.soldOut; stock.dataset.available = result.available;
      fragment.append(card);
    });
    if (appendFrom) grid.append(fragment); else grid.replaceChildren(fragment);
    more.hidden = filtered.length <= limit;
    root.querySelector('[data-progress]').textContent = data.strings.shown.replace('__SHOWN__', Math.min(limit, filtered.length)).replace('__TOTAL__', filtered.length);
  }
  function renderChips() {
    const target = root.querySelector('[data-active]'); target.replaceChildren();
    filterFields.filter(key => key !== 'sort' && key !== 'unit').forEach(key => {
      const value = state[key]; if (!value) return;
      let label = value;
      if (key === 'width') label = value + ' ' + state.unit;
      if (key === 'length') label = data.strings.length + ' ' + value + ' mm';
      if (key === 'availability') label = value === '1' ? data.strings.available : value === '2' ? data.strings.orderable : data.strings.soldOut;
      if (key === 'min') label = data.strings.min + ' ' + value;
      if (key === 'max') label = data.strings.max + ' ' + value;
      const button = document.createElement('button'); button.type = 'button'; button.textContent = label + ' ×'; button.setAttribute('aria-label', data.strings.remove.replace('__LABEL__', label));
      button.addEventListener('click', () => { state[key] = ''; update(true); }); target.append(button);
    });
  }
  function update(push) {
    limit = 24; syncControls(); filtered = filterProducts(data.products, state);
    count.textContent = hasVariantFilters(state)
      ? data.strings.count.replace('__PRODUCTS__', filtered.length).replace('__VARIANTS__', filtered.reduce((n, r) => n + r.variants.length, 0))
      : (filtered.length === 1 ? data.strings.productCountOne : data.strings.productCountOther).replace('__COUNT__', filtered.length);
    root.querySelector('[data-empty]').hidden = filtered.length > 0;
    renderChips(); renderCards();
    if (push) history.pushState(null, '', urlState());
  }
  function applyForm(event) {
    const values = new FormData(form);
    filterFields.filter(key => key !== 'sort').forEach(key => { state[key] = values.get(key) || ''; });
    if (event.target.name === 'wheel' && state.wheel) {
      const units = unique(variants.filter(v => v.eligible === true).flatMap(v => v.bands.filter(b => b.wheel === state.wheel).map(b => b.unit)));
      if (units.length === 1 && units[0] !== state.unit) { state.unit = units[0]; state.width = ''; }
    }
    update(true);
  }
  form.addEventListener('submit', event => { event.preventDefault(); applyForm(event); });
  form.addEventListener('change', applyForm);
  form.addEventListener('reset', event => { event.preventDefault(); state = emptyState(); update(true); });
  sort.addEventListener('change', () => { state.sort = sort.value; update(true); });
  more.addEventListener('click', () => {
    const previousLimit = limit; limit += 24; renderCards(previousLimit);
    const firstNewLink = grid.querySelectorAll('.trp__title')[previousLimit];
    if (firstNewLink) firstNewLink.focus();
  });
  window.addEventListener('popstate', () => { state = readState(location.search); update(false); });
  refreshOptions(); update(false);
  if (entry.searchParams.has('tube_scope') || entry.searchParams.has('tube_category')) history.replaceState(null, '', urlState());
  root.querySelector('[data-fallback]').hidden = true;
  root.querySelector('[data-fallback-note]').hidden = true;
  grid.hidden = false;
  filterDetails.hidden = false;
  root.querySelector('.trp__toolbar').hidden = false;
  root.dataset.ready = 'true';
}());

